export const UPDATTE_PROFILE_PRIVACYMODE_START = 'UPDATTE_PROFILE_PRIVACYMODE_START';
export const UPDATTE_PROFILE_PRIVACYMODE_SUCCESS = 'UPDATTE_PROFILE_PRIVACYMODE_SUCCESS';
export const UPDATTE_PROFILE_PRIVACYMODE_FAILURE = 'UPDATTE_PROFILE_PRIVACYMODE_FAILURE';

export const UPDATTE_PROFILE_PRIVACYMODE_RESET = 'UPDATTE_PROFILE_PRIVACYMODE_RESET';